module.exports = __webpack_public_path__ + "img/switch.0d2feaa9.jpg";